<template>
  <li class="list-group-item">
    <div class="list-item-row">
      <div class="check-list-title">動物の状態</div>
      <div class="check-list-group">
      
				<div class="check-item">
					<div class="label">正常</div>
					<div class="chkbox">
						<input
							type="checkbox"
							id='status-ok'
							v-model="statusOK"
						>
						<label for="status-ok"><div class="tick"></div></label>
					</div>
				</div>

				<div class="check-item">
					<div class="label">異常あり</div>
					<div class="chkbox">
						<input
							type="checkbox"
							id='status-ng'
							v-model="statusNG"
						>
						<label for="status-ng"><div class="tick"></div></label>
					</div>
				</div>

        <button
          @click="openModal"
          class="btn btn-primary"
        >＋メモ</button>
        <CommentModal
          :modalId="modalId"
          :comment="comment"
          :memo="commentStr"
          @closeModal="closeModal"
          @addMemo="addMemo"
        />
      </div>
    </div>

    <div class="comment" v-if="commentStr">
      <h5>メモ</h5>
      <button
        @click="deleteComment"
        class="btn btn-secondary"
      >×</button>
      <div>{{commentStr}}</div>
    </div>
  </li>
</template>

<script>
import axios from "axios";
import CommentModal from "@/components/CommentModal"
export default {
  components: {
    CommentModal
  },
  data() {
    return {
      loading: true,
      modalId: "modalStatus",
      status: null,
      comment: false,
      commentStr: "",
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    openModal() {
      this.comment = true
    },
    closeModal() {
      this.comment = false
    },
    addMemo(data) {
      this.commentStr = data
      this.update()
    },
    deleteComment() {
      this.commentStr = ""
      this.update()
    },
    load() {
      axios
        .get("/wp-json/pasti/v1/checklist/animalstatus")
        .then( response => {
          console.log(response)
          if(response.data.length){
            this.status = response.data[0].IsNormalAnimalStatus === "1" ? true : false
            this.commentStr = response.data[0].memo
          }
          this.loading = false
        })
        .catch( error => {
          console.log(error);
        })
    },
    update() {
      axios
        .post("/wp-json/pasti/v1/checklist/animalstatus", {
          status: this.status,
          disinfection: this.disinfection,
          maintenance: this.maintenance,
          memo: this.commentStr,
          tantouid: this.$props.tantouId,
          tantouname: this.$props.tantouName,
        })
        .then( response => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        });
    }
  },
  computed: {
    statusOK: {
      get() {
        return this.status
      },
      set(value) {
        this.status = value
        this.update()
      }
    },
    statusNG: {
      get() {
        return this.status === false
      },
      set(value) {
        this.status = !value
        this.update()
      }
    },
  }
}
</script>